<div class="loading-group">
<div class="loading-text">携帯打刻端末認証中</div>
<mat-progress-spinner  [diameter]="100" mode="indeterminate" ></mat-progress-spinner>
</div>
